import { ReactElement } from "react";

import useGetProfileData from "hooks/useGetProfileData";

import PageCard from "global-components/pageCard/PageCard";
import AccountSummary from "global-components/accountSummary/AccountSummary";

const Home = (): ReactElement => {
  const { data: profileData } = useGetProfileData();
  const { login = "", email = "" } = profileData;

  return (
    <PageCard
      title="Identity & security settings"
      description="This info will be used for all Justworks products and every company that you work for that uses Justworks."
    >
      <AccountSummary username={login} email={email} />
    </PageCard>
  );
};

export default Home;
